<template>
  <div class="couponBox">
    <div class="list-title">
      我领到的
    </div>
    <ul>
      <li v-for="(item, index) in couponList" :key="index" :class="{'li-customer': item.type === 1, 'li-driver': item.type === 2}">
        <div v-if="item.type === 2" class="couponLeft">
          <div v-if="item.discountFlag" class="customerLeftText driverTextColor">最高返利</div>
          <div v-if="item.discountFlag" class="customerPrice driverPriceColor"><span>{{ item.discountDiscount ? item.discount*10 : item.discount }}</span>%</div>
          <div v-if="!item.discountFlag" class="customerPrice driverPriceColor">￥<span :class="{font: item.price && item.price.length > 3}">{{ item.price || 0 }}</span></div>
        </div>
        <div v-if="item.type === 1" class="couponLeft">
          <div v-if="!item.discountFlag" class="customerLeftText customerLeftTextLeft">立减</div>
          <div v-if="!item.discountFlag" class="customerPrice">¥<span>{{ item.price }}</span></div>
          <div v-if="item.discountFlag" class="customerPrice"><span class="customerPriceSpan">{{ item.discount || 0 }}</span>折</div>
        </div>
        <!-- <div class="couponLine"></div> -->
        <div class="couponRight" :class="{couponRightDriver: item.type === 2, couponP: item.type === 1}">
          <div :class="{'rightText': item.type === 1, 'rightTextDriver': item.type === 2}">{{ item.endTime }}之前有效</div>
          <div class="txtmid" :class="{'rightText': item.type === 1, 'rightTextDriver': item.type === 2, 'txtmidDriver': item.type === 2}">{{ item.name }}</div>
          <div :class="{'rightText': item.type === 1, 'txtbottom': item.type === 1, 'rightTextDriver': item.type === 2, 'txtbottomDriver': item.type === 2}">{{ item.ruleDetail }}</div>
          <div v-if="item.type === 1 && item.useType !== '0' && (item.useType === '1' || item.useType === '2')" class="couponCar">{{ item.useType === "1" ? '顺风车' : '出租车' }}</div>
        </div>
        <!-- <div class="left">
          <div class="title">{{item.name}}</div>
          <div class="valid-time">有效期：{{item.validTime}}</div>
        </div>
        <div class="right" :class="{activeRight: !item.discountFlag}">
          <div class="high" v-if="item.discountFlag">最高抵扣</div>
          <div class="price" :class="{active: item.price.length > 2}" @click="handleToast">
            <div class="icon">￥</div>
            <div class="money">{{item.price}}</div>
          </div>
          <div class="discount" v-if="item.discountFlag">{{item.discount}}<span>折券</span></div>
        </div> -->
      </li>
    </ul>
    <div v-if="coupon.wechat_display" class="official" :style="{background:'url('+ (coupon.wechat_url || 'https://static.didapinche.com/pics/g/93po7lc4f3mgongzhonghao.png') +') no-repeat left top/100%'}" @click="toWechat">
      <div v-show="!coupon.wechat_url" class="officialTxt">关注嘀嗒出行公众号，获取更多福利资讯。</div>
      <div class="officialBtn">关注公众号</div>
    </div>
  </div>
</template>

<script>
  import { getQueryString } from '@common/libs/util.url.js'

  export default {
    name: 'GetcouponList',
    props: ['couponList', 'coupon', 'isApp', 'totalValue', 'guideData'],
    data() {
      return {
        is_jingdong: getQueryString('type') && getQueryString('type') === 'jingdong'
      }
    },
    mounted() {
      const _this = this
      if (this.isLastVersion) {
        // eslint-disable-next-line no-undef
        wx.ready(() => {
          _this.isWxReady = true
          // 需要等待微信ready的时候, 创建微信开放标签
          const pathTaxi = _this.guideData.applet_link || 'pages/index.html' // gh_49e3fa80623f
          const pathCarpool = _this.guideData.applet_link || 'pages/index/index.html'
          _this.htmlStrCarpool = `
            <wx-open-launch-weapp
                username="gh_6da657e25324"
                path="${pathCarpool}"
                style="
                  color: #ffffff !important;
                  line-height: 0.8rem !important;
                  height: 0.80rem !important;
                  outline: none !important;
                  border: 0 none !important;
                  border-radius: 0.5rem !important;
                  font-size: 0.32rem !important;
                  text-align: center !important;
                  width: 6.10rem !important;
                  margin: 0 auto !important;
                  display: flex;
                  background: #ff7d4d !important;
                  justify-content: center;
                  align-items: center;
                "
              >
                <template>
                  <div
                  style="
                    color: #ffffff;
                    text-align:center;
                  "
                  >打开嘀嗒出租车小程序</div>
                </template>
              </wx-open-launch-weapp>
              `
          _this.htmlStrTaxi = `
            <wx-open-launch-weapp
                id="weappCarpool"
                username="gh_49e3fa80623f"
                path="${pathTaxi}"
                style="
                  color: #ffffff !important;
                  line-height: 0.8rem !important;
                  height: 0.80rem !important;
                  outline: none !important;
                  border: 0 none !important;
                  border-radius: 0.5rem !important;
                  font-size: 0.32rem !important;
                  text-align: center !important;
                  width: 6.10rem !important;
                  margin: 0 auto !important;
                  display: flex;
                  background: #ff7d4d !important;
                  justify-content: center;
                  align-items: center;
                "
              >
                <template>
                  <div
                  style="
                    color: #ffffff;
                    text-align:center;
                  "

                  >打开嘀嗒顺风车小程序</div>
                </template>
              </wx-open-launch-weapp>
              `
          // appid="wxd3a1541d4423bf8f"
          _this.htmlStrBtn = `
              <wx-open-launch-app
                appid="wxd3a1541d4423bf8f"
                id="launchapp"
                extinfo="home"
                class="use"
              >
                <template>
                  <div style="color: #ffffff !important;text-align:center !important; padding: 1rem 0 !important;">下载嘀嗒出行App，立即使用</div>
                </template>
              </wx-open-launch-app>
            `
          _this.$nextTick(() => {
            const launchapp = document.getElementById('launchapp')
            const weappCarpool = document.getElementById('weappCarpool')
            if (launchapp) {
              launchapp.addEventListener('ready', e => {
              })
              launchapp.addEventListener('launch', e => {
              })
              launchapp.addEventListener('error', e => {
                _this.goApp()
              })
            }
            if (weappCarpool) {
              weappCarpool.addEventListener('ready', e => {
              })
              weappCarpool.addEventListener('launch', e => {
              })
              weappCarpool.addEventListener('error', e => {
              })
            }
          })
        })
      }
    },
    methods: {
      /**
       * @description: 跳转公众号
       * @param {*}
       * @return {*}
       */
      toWechat() {
        window.location = this.coupon.wechat_link || 'https://mp.weixin.qq.com/s/WiwYxQpe6PIUtva0Dv7lTw'
      },
      handleToast() {
        if (this.is_jingdong) {
          this.$didafe.toast('可在京东金融App中查看', { wordWrap: true })
        } else {
          this.$didafe.toast('可在嘀嗒出行App「钱包-优惠券」中查看', { wordWrap: true })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .couponBox {
    position: relative;
    min-height: 2rem;
    background: #ffffff;
    box-shadow: 0 0.1rem 0.28rem 0 rgba(0, 0, 0, 0.15);
    border-radius: 0.26rem;
  }
  .list-title {
    font-size: 0.32rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 700;
    color: #23292f;
    line-height: 0.44rem;
    padding: 0.48rem 0.4rem 0.24rem;
  }
  ul{
    padding: 0.4rem;
    padding-top: 0;
  }
  ul li {
    // background: url("https://static.didapinche.com/pics/g/hyv4dyih8bicoupon.png") no-repeat left top/100% 100%;
    // background-size: 100% 100%;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0.4rem;
    box-sizing: border-box;
    .couponLeft{
      // height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 1rem !important;
      .customerLeftText{
        // width: 100%;
        font-size: 0.2rem;
        text-align: right;
        color: #b0841c;
        font-family: PingFangS, PingFangSC-Regular;
      }
      .customerLeftTextLeft{
        margin-left: 0.3rem;
      }
      .driverTextColor{
        color: #F55D4F;
      }
      .customerPrice{
        font-size: 0.24rem;
        color: #b0841c;
        font-weight: 700;
        font-family: PingFangS, PingFangSC-Semibold;
        display: flex;
        align-items: baseline;
        .customerPriceSpan{
          margin-right: 0.02rem;
        }
        span{
          font-size: 0.6rem;
          font-family: AvenirNext, AvenirNext-Semibold;
        }
      }
      .driverPriceColor{
        color: #F55D4F;
      }
      .font{
        font-size: 0.36rem !important;
      }
    }
    .couponP{
      border-left: 0.02rem solid rgb(242,226,195);
    }
    .couponRightDriver{
      border-left: 0.02rem solid rgb(253,229,228);
    }
    .couponRight{
      margin-left: 0.18rem;
      padding-left: 0.26rem;
      width: 4rem;
      .rightText{
        font-size: 0.2rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: rgba(176,132,28,0.55);
        line-height: 0.28rem;
      }
      .rightTextDriver{
        font-size: 0.2rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: rgba(245,93,79,0.55);
        line-height: 0.28rem;
      }
      .txtmid{
        font-size: 0.3rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 700;
        color: #b0841c;
        margin-bottom: 0.24rem;
        line-height: 0.42rem;
      }
      .txtmidDriver{
        color: #F55D4F;
      }
      .txtbottom{
        font-size: 0.22rem;
        color: #a87c15;
      }
      .txtbottomDriver{
        font-size: 0.22rem;
        color: #F55D4F;
      }
      .couponCar{
        position: absolute;
        top: 0.3rem;
        right: 0.08rem;
        padding: 0.04rem 0.04rem 0.04rem 0.08rem;
        background: rgba(255,220,88,0.50);
        border-radius: 0.08rem 0 0 0.08rem;
        font-size: 0.2rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #a87c15;
      }
    }
  }
  .li-customer{
    background: url("https://static.didapinche.com/pics/g/3swvokyx0hcustomer.png") no-repeat left top/100% 100%;
  }
  .li-driver{
    background: url("https://static.didapinche.com/pics/g/bqkaro19fgoderiver.png") no-repeat left top/100% 100%;
  }
  ul li:not(:last-of-type) {
    margin-bottom: 0.24rem;
  }
  .left{
    margin: 0.5rem 0 0.5rem 0.5rem;
    color: #FFFFFF;
  }
  .title{
    height: 0.44rem;
    line-height: 0.44rem;
    font-size: 0.32rem;
    margin-bottom: 0.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .valid-time{
    font-size: 0.24rem;
    height: 0.34rem;
    line-height: 0.34rem;
  }
  .right{
    /*width: 1rem;*/
    height: calc(1.88rem - 0.84rem);
    padding: 0.42rem 0.56rem 0.42rem 0;
    color: #FB686E;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
  }
  .activeRight{
    justify-content: center;
  }
  .right .high{
    opacity: 0.7;
    font-size: 0.2rem;
  }
  .right .price{
    font-family: AvenirNext, AvenirNext-DemiBold;
    display: flex;
    align-items: flex-end;
    /*justify-content: flex-end;*/
  }
  .right .price .money {
    height: 0.56rem;
    line-height: 0.56rem;
    font-size: 0.56rem;
  }
  .right .price .icon{
    font-size: 0.22rem;
    font-weight: 700;
    margin-bottom: 0.02rem;
    align-self: flex-end;
  }
  .right .active .money {
    height: 0.34rem;
    line-height: 0.34rem;
    font-size: 0.34rem;
  }
  .right .active .icon {
    font-size: 0.2rem;
    transform: scale(0.75);
  }
  .right .discount{
    font-size: 0.16rem;
    line-height: 0.2rem;
    font-weight: 700;
  }
  .right .discount span{
    font-size: 0.16rem;
    margin-left: 0.03rem;
  }
  .total-value{
    margin: 0.6rem 0 0.36rem;
    font-size: 0.26rem;
    color: #4E556C;
    text-align: center;
  }
  .total-value span{
    // color: #EE9D58;
    color: #A87C15;
    font-weight: 700;
  }

  .official{
    position: relative;
    width: 100%;
    height: 1.72rem;
    background: url('https://static.didapinche.com/pics/g/93po7lc4f3mgongzhonghao.png') no-repeat left top/100%;
    .officialTxt{
      font-size: 0.22rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #4d5663;
      position: absolute;
      top: 0.96rem;
      left: 0.4rem;
    }
    .officialBtn{
      width: 1.6rem;
      height: 0.6rem;
      background: #ffbc00;
      border-radius: 0.08rem;
      position: absolute;
      top: 0.54rem;
      right: 0.4rem;
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #23292f;
    }
  }
</style>

